<template>
  <section>
    <div class="modal-body">
      <form @submit.prevent="submitForm" class="m-form m-form--state" >
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <div class="col-lg-6">
              <label>{{ 'entrance_name' | capitalize }}</label>
              <input type="text" id="entrance_name" v-model="log.entrance_name" readonly name="entrance_name" class="form-control m-input" >
            </div>
            <div class="col-lg-6">
              <label>{{ 'reference_one' |  capitalize }}</label>
              <input type="text" id="reference_one" v-model="log.reference_one" readonly name="reference_one" class="form-control m-input" >
            </div>             
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-6">
              <label>{{ 'action' | capitalize }}</label>
              <input type="text" id="action" v-model="log.action" readonly name="action" class="form-control m-input" >
            </div>
            <div class="col-lg-6">
              <label>{{ 'title' | capitalize }}</label>
              <input type="text" id="title" v-model="log.title" readonly name="title" class="form-control m-input" >
            </div>             
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-6">
              <label>{{ 'name' | capitalize }}</label>
              <input type="text" id="name" v-model="log.user_name" readonly name="name" class="form-control m-input" >
            </div>            
            <div class="col-lg-6">
              <label>{{ 'user' | capitalize }}</label>
              <input type="text" id="user" v-model="log.user_id" readonly name="user" class="form-control m-input" >
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-6">
              <label>{{ 'profile' | capitalize }}</label>
              <input type="text" id="profile" v-model="log.profile" readonly name="profile" class="form-control m-input" >
            </div>
            <div class="col-lg-6">
              <label>{{ 'description' | capitalize }}</label>
              <textarea v-model="log.description" readonly name="description" rows="1" class="form-control form-control-danger m-input"></textarea>              
            </div>           
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-6">
              <label>{{ 'created_at' | capitalize }}</label>
              <input type="text" id="created_at" v-model="log.created_at" readonly name="created_at" class="form-control m-input" >
            </div>
          </div>          
          <div class="form-group m-form__group">
            <label>{{ 'data' | capitalize }}</label>
            <textarea v-model="log.data" readonly name="data" rows="5" class="form-control form-control-danger m-input"></textarea>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="setStatusLogModal(false)" id="btn-cancel">
        {{'close' | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: { data: Object },
  data () {
    return {
      log: {}
    }
  },
  computed: {
    ...mapGetters({modal: 'getStatusLogModal'})
  },
  methods: {
    ...mapActions(['setStatusLogModal', 'getUserName'])
  },
  watch: {
    modal (newVal, oldVal) {
      const self = this
      if (oldVal === false && newVal === true) {
        this.$nextTick(() => {
          self.log = self.data
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Base.vue